import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonDataService } from '../../shared/catalogue/services/common-data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  currentDate = new Date();

  constructor(
    private modalService: NgbModal,
    public commonDataService: CommonDataService
  ) {}

  ngOnInit() {}

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  reloadPage = () => {
    location.reload();
  };
}
